<app-habitation-page-container>
  <div class="page-content">
    <form class="form-wrapper" [formGroup]="propertyForm">
      <div class="titre">
        <h1 appFocusOnInit class="titre-page" id="titre-page" [innerText]="'propriete.creation.titre' | translate"></h1>
        <p class="sous-titre" id="sous-titre" [innerHTML]="'propriete.creation.sous-titre' | translate"></p>
      </div>
      <app-error-message-validation
        id="error-message-validation"
        *ngIf="isErrors"
        [errors]="errorMessageValidation"
        class="error-msg"
      ></app-error-message-validation>
      <div class="information-propriete">
        <h2 class="titre-categorie" [innerText]="'propriete.creation.categorie' | translate"></h2>
        <div class="prix-propriete">
          <label for="prix" class="prix-propriete">{{ 'propriete.creation.label-prix-propriete' | translate }}</label>
          <app-currency-input
            [id]="'prix'"
            [parentFormGroup]="propertyForm"
            [formName]="'prix'"
            [required]="true"
            [textAlign]="isLangFr ? 'right' : 'left'"
            [doesEmitting]="true"
            [minInput]="20000"
            [maxInput]="999999"
            [maxInputErrorMessage]="
              'propriete.detail.erreur-max-prix-propriete' | translate: { maxInput: 999999 | desjardinsCurrency }
            "
            [accessibilityLabel]="'propriete.creation.label-prix-propriete' | translate"
            [shouldDisplayDollarSign]="true"
            (valueChange)="updateMontantFraisRenovationsMaxInput()"
          ></app-currency-input>
        </div>
        <div class="frais-renovation">
          <div class="label-wrapper">
            <label for="montantFraisRenovations" class="label-frais-renovation dsd-mb-0">
              {{ 'propriete.creation.label-frais-renovation' | translate }}
              <span class="facultatif">&nbsp;({{ 'general.facultatif' | translate }})</span>
            </label>
            <app-tooltip
              [ariaLabel]="'propriete.creation.sr-only.infobulle-frais-renovation' | translate"
              class="info-bulle"
              [id]="'frais-renovation-infobulle'"
              [titre]="'propriete.creation.label-frais-renovation' | translate"
              [texte]="'propriete.creation.infobulle-frais-renovation' | translate"
            ></app-tooltip>
          </div>
          <app-currency-input
            [id]="'montantFraisRenovations'"
            [parentFormGroup]="propertyForm"
            [formName]="'montantFraisRenovations'"
            [textAlign]="isLangFr ? 'right' : 'left'"
            [maxInput]="fraisRenovationsMaxInput"
            [doesEmitting]="true"
            [minInput]="0"
            [maxInputErrorMessage]="
              'propriete.detail.erreur-max-frais-renovations' | translate: { numero: numeroMontreal }
            "
            [accessibilityLabel]="'propriete.creation.label-frais-renovation' | translate"
            [shouldDisplayDollarSign]="true"
          ></app-currency-input>
          <ng-container *ngIf="isEditingOldProperty">
            <div>
              <label id="label-nom" for="titrePropriete">
                {{ 'propriete.creation.label-nom' | translate }}
                <span class="facultatif">({{ 'general.facultatif' | translate }})</span>
              </label>
              <mat-form-field appearance="outline" [floatLabel]="'always'">
                <input
                  id="titrePropriete"
                  matInput
                  formControlName="titre"
                  name="input-titre-propriete"
                  maxlength="60"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
            <div>
              <label id="label-type" for="input-type">
                {{ 'propriete.creation.label-type' | translate }}
                <span class="facultatif">({{ 'general.facultatif' | translate }})</span>
              </label>
              <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-select
                  id="input-type"
                  placeholder="{{ 'propriete.creation.type-defaut' | translate }}"
                  formControlName="type"
                  name="select-type-propriete"
                >
                  <mat-option> {{ 'propriete.creation.type-defaut' | translate }}</mat-option>
                  <mat-option *ngFor="let type of typePropriete" [value]="type?.id" [id]="'type-propriete-' + type?.id">
                    {{ type?.typeProprietee }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <label for="proprieteAdresse" class="adresse-propriete">
                {{ 'propriete.creation.label-adresse' | translate }}
                <span class="facultatif">({{ 'general.facultatif' | translate }})</span>
              </label>
              <app-address-input
                [id]="'proprieteAdresse'"
                placeholder=""
                [parentFormGroup]="propertyForm"
                [formName]="'proprieteAdresse'"
                *ngIf="isLoaded"
                [addressComplete]="address"
                [provinces]="['QC']"
                (valueChange)="updateAddress($event)"
                [activePosteCanada]="activePosteCanada"
                [accessibilityLabel]="'propriete.creation.label-adresse' | translate"
              >
              </app-address-input>
            </div>
            <div>
              <label for="notesPropriete" id="label-notes">
                {{ 'propriete.creation.label-notes' | translate }}
                <span class="facultatif">({{ 'general.facultatif' | translate }})</span>
              </label>
              <mat-form-field appearance="outline" [floatLabel]="'always'">
                <textarea
                  class="note-textarea"
                  [matTextareaAutosize]="false"
                  id="notesPropriete"
                  matInput
                  placeholder="{{ 'propriete.creation.notes-placeholder' | translate }}"
                  formControlName="notePersonnelle"
                  maxlength="4000"
                  name="note-input"
                ></textarea>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="frais-propriete">
        <div class="titre-categorie-conteneur">
          <h2 class="titre-categorie">{{ 'propriete.etape-deux.titre' | translate }} <br /></h2>
          <p [innerText]="'propriete.etape-deux.sous-titre' | translate"></p>
        </div>
        <div class="taxes-municipales">
          <div class="label-wrapper">
            <label for="montantTaxesMunicipales" class="label-taxes-municipales">
              {{ 'propriete.etape-deux.label-taxes-municipales' | translate }}
            </label>
            <app-tooltip
              class="info-bulle"
              [id]="'taxes-municipales'"
              [ariaLabel]="'propriete.creation.sr-only.taxes-municipales' | translate"
              [titre]="'propriete.etape-deux.label-taxes-municipales' | translate"
              [texte]="'propriete.etape-deux.taxes-municipales-infobulle' | translate"
            ></app-tooltip>
          </div>
          <app-currency-input
            [id]="'montantTaxesMunicipales'"
            [parentFormGroup]="propertyForm"
            [formName]="'montantTaxesMunicipales'"
            [required]="true"
            [textAlign]="isLangFr ? 'right' : 'left'"
            [frequence]="'general.par-annee'"
            [doesEmitting]="true"
            [minInput]="0"
            [maxInput]="maxInputTaxesMunicipales"
            [maxInputErrorMessage]="
              'propriete.etape-deux.erreur-max-taxes-municipales'
                | translate: { maxInput: maxInputTaxesMunicipales | desjardinsCurrency }
            "
            [accessibilityLabel]="'propriete.etape-deux.label-taxes-municipales' | translate"
          ></app-currency-input>
        </div>
        <div class="taxes-scolaires">
          <div class="label-wrapper">
            <label for="montantTaxesScolaires" class="label-taxes-scolaires">
              {{ 'propriete.etape-deux.label-taxes-scolaires' | translate }}
            </label>
            <app-tooltip
              class="info-bulle"
              [id]="'taxes-scolaires'"
              [ariaLabel]="'propriete.creation.sr-only.taxes-scolaires' | translate"
              [titre]="'propriete.etape-deux.label-taxes-scolaires' | translate"
              [texte]="'propriete.etape-deux.infobulle-taxes-scolaires' | translate"
            ></app-tooltip>
          </div>
          <app-currency-input
            [id]="'montantTaxesScolaires'"
            [parentFormGroup]="propertyForm"
            [formName]="'montantTaxesScolaires'"
            [required]="true"
            [textAlign]="isLangFr ? 'right' : 'left'"
            [frequence]="'general.par-annee'"
            [doesEmitting]="true"
            [minInput]="0"
            [maxInput]="maxInputTaxesScolaires"
            [maxInputErrorMessage]="
              'propriete.etape-deux.erreur-max-taxes-scolaires'
                | translate: { maxInput: maxInputTaxesScolaires | desjardinsCurrency }
            "
            [accessibilityLabel]="'propriete.etape-deux.label-taxes-scolaires' | translate"
          ></app-currency-input>
        </div>
        <div class="couts-energies">
          <div class="label-wrapper">
            <label for="montantCoutEnergie" class="label-couts-energies">
              {{ 'propriete.etape-deux.label-cout-energie' | translate }}
            </label>
            <app-tooltip
              class="info-bulle"
              [id]="'couts-energie'"
              [ariaLabel]="'propriete.creation.sr-only.couts-energie' | translate"
              [titre]="'propriete.etape-deux.label-cout-energie' | translate"
              [texte]="'propriete.etape-deux.infobulle-cout-energie' | translate"
            ></app-tooltip>
          </div>
          <app-currency-input
            [id]="'montantCoutEnergie'"
            [parentFormGroup]="propertyForm"
            [formName]="'montantCoutEnergie'"
            [required]="true"
            [textAlign]="isLangFr ? 'right' : 'left'"
            [frequence]="'general.par-mois'"
            [doesEmitting]="true"
            [minInput]="0"
            [maxInput]="maxInputCoutEnergie"
            [maxInputErrorMessage]="
              'propriete.etape-deux.erreur-max-couts-energie'
                | translate: { maxInput: maxInputCoutEnergie | desjardinsCurrency }
            "
            [accessibilityLabel]="'propriete.etape-deux.label-cout-energie' | translate"
          ></app-currency-input>
        </div>
        <div class="frais-copropriete">
          <div class="label-wrapper">
            <label for="montantFraisCopropriete" class="label-frais-copropriete">
              {{ 'propriete.etape-deux.label-frais-condo' | translate }}
              <span class="facultatif">&nbsp;({{ 'general.facultatif' | translate }})</span>
            </label>
            <app-tooltip
              class="info-bulle"
              [id]="'frais-condo'"
              [ariaLabel]="'propriete.creation.sr-only.frais-condo' | translate"
              [titre]="'propriete.etape-deux.label-frais-condo' | translate"
              [texte]="'propriete.etape-deux.infobulle-frais-condo' | translate"
            ></app-tooltip>
          </div>
          <p class="info dsd-b-40 dsd-mb-0" [innerText]="'propriete.etape-deux.info-label-frais-condo' | translate"></p>
          <app-currency-input
            [id]="'montantFraisCopropriete'"
            [parentFormGroup]="propertyForm"
            [formName]="'montantFraisCopropriete'"
            [required]="false"
            [textAlign]="isLangFr ? 'right' : 'left'"
            [frequence]="'general.par-mois'"
            [doesEmitting]="true"
            [minInput]="0"
            [maxInput]="maxInputFraisCopropriete"
            [maxInputErrorMessage]="
              'propriete.etape-deux.erreur-max-frais-copropriete'
                | translate: { maxInput: maxInputFraisCopropriete | desjardinsCurrency }
            "
            [accessibilityLabel]="'propriete.etape-deux.label-frais-condo' | translate"
          ></app-currency-input>
        </div>
      </div>

      <div class="btn-container desktop" [class.btn-container--cancel]="formMode !== 'create'">
        <ng-container [ngTemplateOutlet]="backButton"></ng-container>
        <ng-container [ngTemplateOutlet]="submitButton"></ng-container>
      </div>
      <div class="btn-container mobile" [class.btn-container--cancel]="formMode !== 'create'">
        <ng-container [ngTemplateOutlet]="submitButton"></ng-container>
        <ng-container [ngTemplateOutlet]="backButton"></ng-container>
      </div>
    </form>

    <app-dialog-faq class="faq-button" buttonStyle="textOnly" position="center" id="'faq'"></app-dialog-faq>
  </div>
</app-habitation-page-container>

<ng-template #submitButton>
  <button type="submit" id="btn-suivant" class="btn-suivant green right btn-next" mat-button (click)="saveProperty()">
    {{ submitButtonLabel | translate }}
  </button>
</ng-template>

<ng-template #backButton>
  <button
    type="reset"
    id="btn-precedent"
    mat-button
    class="left no-border "
    [class.btn-precedent]="formMode === 'create'"
    [class.btn--cancel]="formMode !== 'create'"
    (click)="cancel()"
  >
    <img
      *ngIf="formMode === 'create'"
      src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}"
      alt=""
      class="button-icone-left"
    />
    <span *ngIf="formMode === 'create'">{{
      (lastUrl === '/' ? 'btn.retour-accueil' : 'btn.precedent') | translate
    }}</span>
    <span *ngIf="formMode !== 'create'">{{ 'btn.annuler' | translate }}</span>
  </button>
</ng-template>
